var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropdownDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9969 19.1998C8.02515 19.1998 4.79688 15.9715 4.79688 11.9998C4.79688 8.02808 8.02515 4.7998 11.9969 4.7998C15.9686 4.7998 19.1969 8.02808 19.1969 11.9998C19.1969 15.9715 15.9686 19.1998 11.9969 19.1998ZM11.9969 5.80446C8.58106 5.80446 5.80153 8.58399 5.80153 11.9998C5.80153 15.4156 8.58106 18.1952 11.9969 18.1952C15.4127 18.1952 18.1922 15.4156 18.1922 11.9998C18.1922 8.58399 15.4127 5.80446 11.9969 5.80446ZM10.1013 14.3975C9.97408 14.3975 9.84683 14.3506 9.74636 14.2501C9.55213 14.0559 9.55213 13.7344 9.74636 13.5402L11.2868 11.9997L9.74636 10.4592C9.55213 10.265 9.55213 9.94353 9.74636 9.74929C9.9406 9.55506 10.2621 9.55506 10.4563 9.74929L11.9968 11.2898L13.5372 9.74929C13.7315 9.55506 14.053 9.55506 14.2472 9.74929C14.4414 9.94353 14.4414 10.265 14.2472 10.4592L12.7067 11.9997L14.2472 13.5402C14.4414 13.7344 14.4414 14.0559 14.2472 14.2501C14.1467 14.3506 14.0195 14.3975 13.8922 14.3975C13.765 14.3975 13.6377 14.3506 13.5372 14.2501L11.9968 12.7097L10.4563 14.2501C10.3625 14.3506 10.2286 14.3975 10.1013 14.3975Z",
    fill: "#5A5C61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownDeleteIcon);
export default __webpack_public_path__ + "static/media/dropdown-delete-icon.c3e5b3c10c8b6c17f01196a0d8ac746a.svg";
export { ForwardRef as ReactComponent };